import { render, staticRenderFns } from "./assetdetail.vue?vue&type=template&id=e26ee48a&scoped=true"
import script from "./assetdetail.vue?vue&type=script&lang=js"
export * from "./assetdetail.vue?vue&type=script&lang=js"
import style0 from "./assetdetail.vue?vue&type=style&index=0&id=e26ee48a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e26ee48a",
  null
  
)

export default component.exports